<template>
  <div id="freeGiftZone">
    <main>
      <van-radio-group v-model="skuid" @change="choice">
        <ul>
          <li v-for="(v, i) in listArr.giftlist" :key="i">
            <div class="leftChecked">
              <van-radio
                :name="v.skuid"
                checked-color="#fc0324"
              ></van-radio>
            </div>
            <div class="rightListDetail" @click="godetail(v)">
              <div class="listImg"><img v-lazy="v.img_path" /></div>
              <div class="listText">
                <div class="textOne">
                  <div>{{ v.name }}</div>
                  <div>x1</div>
                </div>
                <div class="textTwo">{{ v.spec }}</div>
                <div class="xian">
                  <span class="smallprice" v-if="v.price">
                    <sub>¥</sub>
                    <b>{{v.price ? String(parseFloat(v.price).toFixed(2)).slice(0, String(parseFloat(v.price).toFixed(2)).indexOf('.')) : '0'}}</b>
                    <sup>{{v.price ? String(parseFloat(v.price).toFixed(2)).slice(String(parseFloat(v.price).toFixed(2)).indexOf('.'), String(parseFloat(v.price).toFixed(2)).length) : '.00'}}</sup>
                  </span>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </van-radio-group>
    </main>
    <footer>
      <div class="sureBtn" @click="submit">确定</div>
    </footer>
  </div>
</template>
<script>
// import { customRequestAjax } from "@/axiosApi";
import { fenxiang, unencryption } from '../../assets/common/js/config'
/*eslint-disable*/
export default {
  name: "freeGiftZone",
  beforeRouteEnter(to, from, next) {
    next();
  },
  data() {
    return {
      listArr: [],
      skuid: ''
    };
  },
  mounted() {
    fenxiang({path: freeGiftZone})
    this.getData()
    // console.log(JSON.parse(JSON.parse(sessionStorage.getItem('shopConfirmResult')).gift_list));
  },
  methods: {
    getData: function () {
      var that = this
      if (localStorage.getItem('shopConfirmResult')) {
        var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
        this.listArr = JSON.parse(shopConfirmResult.gift_list)[0]
        this.skuid = shopConfirmResult.gift_choose_skuid ? shopConfirmResult.gift_choose_skuid : ''
        console.log(this.skuid)
        this.listArr.giftlist.map(function (item) {
          if (that.skuid == item.skuid) {
            item.ischoose == 1
          } else {
            item.ischoose == 0
          }
        })
      }
    },
    choice: function (skuid) {
      console.log(skuid)
      this.listArr.giftlist.forEach(function (v, i) {
        if (v.skuid == skuid) {
          v.ischoose = 1
        } else {
          v.ischoose = 0
        }
      })
    },
    godetail (items) {
      this.$router.push({
        path: '/productdetail',
        query: {
          itemid: items.itemid,
          type: 'changebuyproductdetail',
          gift: 'gift'
        }
      })
    },
    submit: function () {
      var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
      shopConfirmResult.gift_list = JSON.stringify([this.listArr])
      shopConfirmResult.gift_choose_skuid = this.skuid
      localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
      this.$router.replace({
        path: unencryption(this.$route.query.path)
      })
    },
  },
};
</script>

<style lang="scss" scoped>
#freeGiftZone {
  main {
    padding: 0.1rem;
    background: #eee;
    ul {
      background: white;
      border-radius: 0.04rem;
      padding: 0.15rem 0.15rem 0 0.12rem;
      overflow: hidden;
      li {
        margin: 0 0 0.15rem 0;
        height: 0.8rem;
        display: flex;
        align-items: center;
        .leftChecked {
          font-size: 0.2rem;
        }
        .rightListDetail {
          display: flex;
          align-items: center;
          height: 0.8rem;

          .listImg {
            width: 0.8rem;
            height: 0.8rem;
            margin: 0 0.08rem;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .listText {
            width: 2.12rem;
            height: 0.8rem;
            .textOne {
              width: 100%;
              display: flex;
              justify-content: space-between;
              div:nth-of-type(1) {
                font-size: 0.13rem;
                overflow : hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              }
              div:nth-of-type(2) {
                font-size: 0.1rem;
                color: #6c6c6c;
              }
            }
            .textTwo {
              font-size: 0.12rem * 0.83;
              color: #6c6c6c;
              margin-top: 0.12rem;
            }
            .xian {
              color: #fc0324;
              font-size: 0.12rem;
              text-align: left;
              margin-top: 0.16rem;
              .smallprice {
                font-size: 0;
                line-height: 0.12rem;
              }
              b {
                font-size: 0.13rem;
                line-height: 0.12rem;
                font-weight: 500;
              }
              sub {
                font-weight: normal;
                font-size: .12rem;
                vertical-align: baseline
              }
              sup {
                font-size: .12rem;
                vertical-align: baseline;
                font-weight: 500;
              }
              .bigprice {
                font-size: 0;
                line-height: .2rem;
                b {
                  font-size: .21rem;
                  line-height: .2rem;
                  font-weight: 500;
                }
              }
            }
          }
        }
      }
    }
  }
  footer {
    position: fixed;
    bottom: 0;
    left: 0;
    border-top: 2px solid #dfdfdf;
    background: white;
    width: 100%;
    height: 0.48rem;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .sureBtn {
      width: 1.12rem;
      height: 0.38rem;
      background: linear-gradient(90deg, #fc0324 0%, #ff144f 100%);
      font-size: 0.16rem;
      text-align: center;
      line-height: 0.38rem;
      border-radius: 0.19rem;
      margin-right: 0.1rem;
      color: white;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shopcart/freeGiftZone.vue